import React from 'react';
import { Header, SubFooter } from 'Atoms/';
import { Change } from 'Molecules/';

export default function change() {
  return (
    <div>
      <Header
        classType="header-int"
        title1="Waiʻānapanapa"
        title2="State Park"
        url="waianapanapa"
      />
      <Change url="waianapanapa" parkid="61dd69adf4476d02b032ae48" />
      <SubFooter name="Waiʻānapanapa State Park" url="waianapanapa" />
    </div>
  );
}
